export default __webpack_public_path__ + "static/media/cross-12px-8B8B8B.48120fe0.svg";